module.exports = __webpack_public_path__ + "img/icon-yuan-3.d0aad8b1.png";